const VERSION = '2.6.5';
export function getVersionString() {
    return VERSION;
}
